import React from 'react';
import styled from 'styled-components';
import StackTrace from 'stacktrace-js';
import { appClient, track } from 'lib';

import { Button } from '@/client/widgets/ui';

const Wrap = styled.div`
  padding: 100px;
  text-align: center;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  h2 {
    font-size: var(--fs-md);
    padding: 20px;
  }
  button {
  }
`;

type IState = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<
  { from: string; hideTip?: boolean },
  IState
> {
  constructor(props) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI

    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can use your own error logging service here

    StackTrace.fromError(error)
      .then((stackFrames) => {
        track.send({
          event: 'pageError',
          event_type: 'errorBoundary',
          content: {
            from: this.props.from,
            err: error,
            errorInfo,
          },
          stackFrames,
        });
      })
      .catch((catchError) => {
        track.send({
          event: 'pageError',
          event_type: 'errorBoundaryCatch',
          content: {
            error,
            catchError,
            from: this.props.from,
          },
        });
      });
  }

  handleExit = () => {
    appClient.exitApp();
  };

  render() {
    // Check if the error is thrown
    if (this.state.hasError && !this.props.hideTip) {
      // You can render any custom fallback UI
      return (
        <Wrap>
          <h2>很抱歉，页面开小差了</h2>
          <Button type="primary" onClick={this.handleExit}>
            退出
          </Button>
        </Wrap>
      );
    }

    // Return children components in case of no error

    return this.props.children;
  }
}

export default ErrorBoundary;
